var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      !_vm.messages
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.messages, function(message) {
                    return _c(
                      "tr",
                      {
                        key: message.id,
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.$_can("leads.follow-ups.index") &&
                              _vm.chatHistory(
                                message.lead_id,
                                message.lead_follow_up_id
                              )
                          }
                        }
                      },
                      [
                        _c("td", { staticClass: "text-center" }, [
                          _c("div", { class: message.new && "dot-blue" })
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(message.date))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "py-2 text-wrap" }, [
                          _vm._v(_vm._s(message.body))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "LeadsEdit",
                                    params: { id: message.lead_id }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(message.lead_ref_id) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(message.cluster_user_name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(message.company_name))])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.messages && !_vm.messages.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "8" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _vm.meta.total
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-md-6 mb-1 text-black-50 d-none d-md-block"
                      },
                      [
                        _vm._v(
                          "\n        Showing " +
                            _vm._s(_vm.meta.from) +
                            " - " +
                            _vm._s(_vm.meta.to) +
                            " of " +
                            _vm._s(_vm.meta.total) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-md-6 mb-1 pr-0",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Chat history")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Send to")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "form-control" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.thread.meta.receiver.phone
                                  ? _vm.phoneMask.maskedPhone(
                                      _vm.thread.meta.receiver.phone
                                    )
                                  : "No phone added"
                              ) +
                              "\n              "
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mb-4 scrollable" },
                    _vm._l(_vm.thread.data, function(message) {
                      return _c(
                        "div",
                        { key: message.id, staticClass: "col-12" },
                        [
                          message.direction === 2
                            ? [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-9 bg-primary rounded" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "m-1 text-white" },
                                        [_vm._v(_vm._s(message.body))]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(message.media, function(media) {
                                        return _c(
                                          "p",
                                          {
                                            key: media.id,
                                            staticClass:
                                              "w-25 text-media pointer",
                                            on: {
                                              click: function($event) {
                                                _vm.openFile(media.url)
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "img img-fluid",
                                              attrs: { src: media.url, alt: "" }
                                            })
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-3" })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row mb-2" }, [
                                  _c("div", { staticClass: "col" }, [
                                    _c("small", { staticClass: "m-1" }, [
                                      _vm._v(_vm._s(message.date))
                                    ])
                                  ])
                                ])
                              ]
                            : [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-3" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-9 bg-light rounded" },
                                    [
                                      _c("p", { staticClass: "m-1" }, [
                                        _vm._v(_vm._s(message.body))
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(message.media, function(media) {
                                        return _c(
                                          "p",
                                          {
                                            key: media.id,
                                            staticClass:
                                              "w-25 text-media pointer",
                                            on: {
                                              click: function($event) {
                                                _vm.openFile(media.url)
                                              }
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "img img-fluid",
                                              attrs: { src: media.url, alt: "" }
                                            })
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row mb-2" }, [
                                  _c("div", { staticClass: "col text-right" }, [
                                    _c("small", { staticClass: "m-1" }, [
                                      _vm._v(_vm._s(message.date))
                                    ])
                                  ])
                                ])
                              ]
                        ],
                        2
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-10 pr-0" }, [
                      _c("div", { staticClass: "select-wrap h-auto" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.thread.meta.sender.company_name) +
                              " " +
                              _vm._s(_vm.thread.meta.sender.phone) +
                              ":"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { attrs: { contenteditable: "true" } }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newMessage,
                                expression: "newMessage"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { disabled: _vm.sending },
                            domProps: { value: _vm.newMessage },
                            on: {
                              keypress: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.send($event)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.newMessage = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-2 pl-0" }, [
                      _vm.$_can("leads.follow-ups.store")
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "pt-2 w-100 btn btn-primary ld-ext-right",
                              class: _vm.sending ? "running" : "",
                              attrs: {
                                type: "button",
                                disabled: !_vm.newMessage || _vm.sending
                              },
                              on: { click: _vm.send }
                            },
                            [
                              _c("span", { staticClass: "mod-icon-note" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "ld ld-ball ld-flip" })
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
        _c("div", { staticClass: "col-8" }, [_c("h1", [_vm._v("Messages")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "m-table__heading" }, [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticClass: "m-table__id" }, [_vm._v("Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Message")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lead")]),
        _vm._v(" "),
        _c("th", [_vm._v("User")]),
        _vm._v(" "),
        _c("th", [_vm._v("Company")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a342948a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a342948a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SettingsMessages.vue
// module id = null
// module chunks = 